import { Component } from 'opus-angular-seed-core';
import template from './template.html';

/**
 * The heading of a section of the chapter list.
 */
@Component({
    bindings: {
        section: '<',
        isActive: '<',
        onToggleMenu: '&',
        onStartEdit: '&',
        onFinishEdit: '&',
        onDelete: '&',
        onAddChapter: '&',
        onSetChaptersVisibility: '&'
    },
    template
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/toc/section/index.js